export type RFITicketStatus =
  | 'Submitted'
  | 'Acknowledged'
  | 'Resolved'
  | 'Closed'
  | 'Assigned'
  | 'InvoiceDisputed'
  | 'ProcessingInvoice'
  | 'InvoicePaid'
  | 'InvoiceRejected'
  | 'RFQInProgress'
  | 'RFQRejected'
  | 'RFQSuccess'
  | 'RFQInDispute';

export const RFIStatusColor = {
  Submitted: { bg: 'rgb(222, 222, 222)', text: '#000' },
  Acknowledged: { bg: 'rgb(255, 200, 0)', text: '#000' },
  Resolved: { bg: 'rgb(17, 115, 75)', text: '#fff' },
  Closed: { bg: 'rgb(10, 83, 168)', text: '#fff' },
  Assigned: { bg: 'rgb(255, 169, 0)', text: '#000' },
  Overdue: { bg: '#cf1322', text: '#fff' },
  Pending: { bg: 'rgb(255, 200, 0)', text: '#000' },
};

export type RFITicketType =
  | 'RIC'
  | 'CIC'
  | 'FIC'
  | 'HIC'
  | 'EIC'
  | 'PIC'
  | 'TIC'
  | 'NOT_SET'
  | 'Submission of Invoice'
  | 'GRN_DISPUTE';

export type RFITicket = {
  updated_at: string; // "2023-12-14 06:12:10"
  created_at: string; // "2023-12-14 06:12:10"
  id: number; // 5
  rfi_number: string; // "SS-CS-0000005"
  region: string; // "SG"
  is_all_region: boolean; // false
  request_msg: string; // "I need some improvement and new FE engineer for my team 2"
  requester_name: string; // "Herman Test 3"
  requester_email: string; // "budi+03@sourcesage.co"
  requester_company_email: string; // "budi+04@sourcesage.co"
  requester_company_name: string; // "SourceSage+02 Pte Ltd"
  phone_number?: string; // null
  created_by_id?: number; //null
  created_by?: unknown; // null
  action_by_id?: number; // null
  action_by?: { full_name: string; username?: string }; // null
  sme_marketplace_id?: number; // null
  marketplace_name?: string; // null
  entity_id: number; // null
  order_id: number; // null
  po_number: string; // "006-009"
  supplier_id?: number;
  date_needed_by: string; // "2023-12-30 04:46:00"
  comments?: string; // null
  status: RFITicketStatus; // "Submitted"
  rfi_type: RFITicketType; // "NOT_SET"
  rfi_upload_files: FileUpload[];
  entity?: {
    name: string;
  };
  supplier?: {
    id: number;
    name: string;
  };
  qna_items: Array<{
    id: number;
    question?: string;
    answer?: string;
    note?: string;
  }>;
  resolution_date?: string;
  revised_dateline?: string;
  created_by_rfi_user?: {
    email: string;
    full_name: string;
  };
  is_over_due: boolean;
};

export type RFIRegionMarketplace = {
  id: number;
  sequence: number;
  region: string;
  name: string;
  complete_name: string;
  sme_markeplace_ids?: string;
  is_enabled: boolean;
};

export enum RFIQuestionType {
  STRING = 'STRING',
  CHECKBOX = 'CHECKBOX',
  RADIO = 'RADIO',
  DROPDOWN = 'DROPDOWN',
  DATE = 'DATE',
  TIME = 'TIME',
  DATETIME = 'DATETIME',
}

export type RFIQuestionItem = {
  updated_at: string;
  created_at: string;
  id: number;
  rfi_region_question_id: 5;
  is_all_region: boolean;
  is_mandatory?: null;
  sequence: number;
  is_enabled?: boolean;
  question: string;
  map_field_name?: string;
  question_type: RFIQuestionType;
  rfi_region_question: {
    id: number;
    region: string;
  };
  answer_json?: {
    answers: string[];
    show_other_answer: boolean;
  };
  answer_rule?: RFIAnswerRule[];
};

export type FormAdditionalAnswer = {
  id: number;
  rfi_region_question_item_id: number;
  question: string;
  answer: string;
  note: string;
};

export type RFITicketAgingReport = {
  action_by_id: string;
  age_group: string;
  ticket_count: number;
};

export type RFIAnswerRule = {
  actions: { behavior: string; value: string };
  conditions: { field: string; value: string; operator: string };
};
